module.exports = __webpack_public_path__ + "static/yelp-logo-color-c1b9a611ec87bb3208b71cd8209d1582.svg";